import { paginateItems } from "./adminOrders";

export const CATEGORY_PAGE_SIZES = [20, 50, 100];

export const CATEGORY_SORT_OPTIONS = [
  { value: "tree", label: "Tree order" },
  { value: "name_asc", label: "Name: A–Z" },
  { value: "name_desc", label: "Name: Z–A" },
  { value: "order_asc", label: "Sort order: low to high" },
  { value: "order_desc", label: "Sort order: high to low" },
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
];

function getParentName(row) {
  if (row.path?.length > 1) return row.path[row.path.length - 2];
  return "";
}

function getSearchHaystack(row) {
  return [
    row.name,
    row.slug,
    row.label,
    row.description,
    getParentName(row),
    ...(row.path || []),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

function compareCategories(a, b, sortBy, indexMap) {
  switch (sortBy) {
    case "name_asc":
      return String(a.name || "").localeCompare(String(b.name || ""), undefined, {
        sensitivity: "base",
      });
    case "name_desc":
      return String(b.name || "").localeCompare(String(a.name || ""), undefined, {
        sensitivity: "base",
      });
    case "order_asc":
      return Number(a.sortOrder || 0) - Number(b.sortOrder || 0);
    case "order_desc":
      return Number(b.sortOrder || 0) - Number(a.sortOrder || 0);
    case "newest":
      return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
    case "oldest":
      return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
    case "tree":
    default:
      return (indexMap.get(String(a.id)) || 0) - (indexMap.get(String(b.id)) || 0);
  }
}

/**
 * Enrich flattenCategoryOptions rows with fields from the raw category docs.
 */
export function enrichCategoryRows(flatRows, categories = []) {
  const byId = new Map(
    categories.map((c) => [String(c._id || c.id), c])
  );
  return flatRows.map((row, index) => {
    const raw = byId.get(String(row.id));
    return {
      ...row,
      treeIndex: index,
      description: raw?.description || "",
      createdAt: raw?.createdAt || null,
      updatedAt: raw?.updatedAt || null,
      childCount: row.children?.length || 0,
      raw,
    };
  });
}

export function filterAndSortCategories(rows, filters) {
  const {
    search = "",
    status = "all",
    level = "all",
    sortBy = "tree",
  } = filters;

  const query = search.trim().toLowerCase();
  const indexMap = new Map(
    rows.map((row, index) => [String(row.id), row.treeIndex ?? index])
  );

  const filtered = (rows || []).filter((row) => {
    if (status === "active" && !row.isActive) return false;
    if (status === "inactive" && row.isActive) return false;
    if (level === "top" && row.depth !== 0) return false;
    if (level === "sub" && row.depth === 0) return false;
    if (query && !getSearchHaystack(row).includes(query)) return false;
    return true;
  });

  return [...filtered].sort((a, b) => compareCategories(a, b, sortBy, indexMap));
}

export { paginateItems };
